import floor from 'lodash/floor';
import {
    SELECTION_ODDS_DECIMAL_PRECISION_HIGHER,
    SELECTION_ODDS_DECIMAL_PRECISION_LOWER,
} from './constants';

/**
 * Returns the decimal price to the correct number of decimal places
 *
 * @param  {string/number} price The selection price, it's normally a string but can be a number from MultiBetButton
 * @returns {number} The price to the correct decimal places
 */
export const decimalPriceOdds = (price) => {

    // Ensure price is a valid number; return as is if not.
    if (typeof price === 'undefined' || isNaN(price)) {
        return price;
    }

    const formattedPrice = Number(price).toFixed(SELECTION_ODDS_DECIMAL_PRECISION_HIGHER);

    if (!formattedPrice.includes('.')) {
        return formattedPrice;
    }

    const [, decimalPart] = formattedPrice.split('.');

    if (Number(formattedPrice) >= 1.1 || decimalPart[2] === '0') {
        return floor(price, SELECTION_ODDS_DECIMAL_PRECISION_LOWER).toFixed(SELECTION_ODDS_DECIMAL_PRECISION_LOWER);
    }

    return formattedPrice;
};
